import { render, staticRenderFns } from "./Menulist.vue?vue&type=template&id=bcf95448"
import script from "./Menulist.vue?vue&type=script&lang=js"
export * from "./Menulist.vue?vue&type=script&lang=js"
import style0 from "./Menulist.vue?vue&type=style&index=0&id=bcf95448&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports